import $ from 'jquery';


import ScrollMagic from 'scrollmagic';
import TweenMax from 'gsap';
import TimelineMax from 'gsap/TimelineMax';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

class RegisterForm {
	
	constructor(currentStatus) {

		if( $(".register-gallery__link").length > 0 ) {
			this.init();
		}

	}

	init() {
		var self = this;
		(function (SHFormLoader, $) {
			$.get( BJZM_DATA.ajaxurl + '?action=gf_button_get_form&form_id=1',function(response){
				$('#gf_button_form_container_1').html(response).fadeIn();
		

		self.links = $(".register-gallery__link");
		self.formPropertiesContainer = $(".properties-wrapper");
		self.doGalleryEvents();
		self.materialInput();
		self.checkProperty();
		if( $(window).outerWidth() > 991 ) {
			self.setFormDimenions();
			setTimeout(() => {
				self.doStickyForm();
			}, 1000);
			self.resizeDimensions();
		}
		self.initGravyityFormsScripts();
		self.gravityFormConfirtmation();
		self.doGravityFormScripts();

			});
		}(window.SHFormLoader = window.SHFormLoader || {}, jQuery));
	}

	gravityFormConfirtmation() {
		this.formIsSubmitted = false;

		var self = this;

		jQuery(document).bind('gform_confirmation_loaded', function(event, formId){
			self.formIsSubmitted = true;
			$(".register-container__content").removeClass("register-container__content--not-submitted").removeClass("register-container__content--sticky").removeClass('register-container__content--semi-sticky');
			$('html,body').animate({ scrollTop: 0 }, 'slow');
			$(".register-gallery__inner").addClass("register-gallery__inner--hide");
		});
	}

	initGravyityFormsScripts() {
		$(document).on('gform_post_render', (e, form_id) => {
		    if ( jQuery('div.validation_error').length > 0 ) {
		    	this.doGravityFormScripts();
		    }
		    else {
		    	// console.log('initGravyityFormsScripts NO ERROR');
		    }
		});
	}

	doGravityFormScripts() {
		this.links = $(".register-gallery__link");
		this.formPropertiesContainer = $(".properties-wrapper");
		if( this.formPropertiesContainer.hasClass('gfield_error') ) {
			$(".register__step--one").addClass('step-error');
		}
		else {
			$(".register__step--one").removeClass('step-error');	
		}
		this.materialInput();
		this.checkProperty();
		// this.doGalleryEvents();
	}

	resizeDimensions() {
		var self = this;
		$(window).on('resize', function(){
			self.setFormDimenions();
		});
	}

	setFormDimenions() {
		this.formWidth = $(".column-wrapper--register").outerWidth() / 2 - 25;
		this.formHeight = $(".column-wrapper--register").outerHeight();
		$(".register-container__sticky").css('width', this.formWidth);
		
		if( $(window).height() > $(".register-container__sticky").outerHeight() ) {
			this.offset = ($(".register-container__sticky").offset().top - $(".header").outerHeight() + 50) * -1;	/*working with window taller than form */
		}	
		else {
			this.offset = $(".register-container__sticky").outerHeight() - $(window).outerHeight();	/*working with the window shorter than the form*/
		}
	}

	doStickyForm() {

		var controller = new ScrollMagic.Controller();
		var $form = $(".register-container__sticky");
		var self = this;

		var stickyFormScene = new ScrollMagic.Scene({ 
			triggerElement: ".register-container__content",
			offset: self.offset,
			duration: $form.outerHeight() + 140,
			triggerHook: 'onLeave'
		})
		// .addIndicators()
		.setClassToggle(".register-container__content--not-submitted", 'register-container__content--sticky')
		.addTo(controller);

		var unStickyFormScene = new ScrollMagic.Scene({ 
			triggerElement: ".footer--main",
			triggerHook: 'onEnter',
		})
		// .addIndicators()
		.setClassToggle(".register-container__content--not-submitted", 'register-container__content--semi-sticky')
		.addTo(controller);

	}

	materialInput() {

		$('input[type="text"]').on("focus", function(){
			var $gfield = $(this).closest('.gfield');
			$gfield.addClass('gfield--is-focused');

		});
		$('input[type="text"]').on("focusout", function(){
			var $gfield = $(this).closest('.gfield');
			var value = $(this).val();
			if(value == "") {
				$gfield.removeClass('gfield--is-focused');
			}
		});

		$('input[type="text"]').each(function(){
			var $gfield = $(this).closest('.gfield');
			var value = $(this).val();
			if(value == "") {
				$gfield.removeClass('gfield--is-focused');
			}
			else {
				$gfield.addClass('gfield--is-focused');
			}
		});

	}

	doGalleryEvents() {

		this.links.on('click', (e) => {
			e.preventDefault();
			let $link = $(e.currentTarget);
			let $parent = $link.closest(".register-gallery__property");
			let thisProperty = $link.data('property');
			this.checkProperty(thisProperty);
			if( $parent.hasClass('register-gallery__property--active')) {
				$parent.removeClass('register-gallery__property--active');
			}
			else {
				$parent.addClass('register-gallery__property--active');
			}

		});
	}

	checkProperty(thisProperty) {
		let $propertyCheckBox = this.formPropertiesContainer.find(`input[type="checkbox"][value="${thisProperty}"] `);
		let checked = $propertyCheckBox.is(":checked");
		let setChecked = !checked;
		$propertyCheckBox.prop('checked', setChecked);
	}

}

module.exports = RegisterForm;